import React from 'react';

const ImageWithText = function ({image, text, prefixClassName}) {
	return (
		<span>
			{(image && (
				<img
					className={prefixClassName('image')}
					onLoad={(e) => {
						e.currentTarget.style.display = 'block';
					}}
					onError={(e) => {
						e.currentTarget.style.display = 'none';
					}}
					src={`/apps/kulturnacht2025/php/image-proxy.php?image=${encodeURIComponent(
						image
					)}`}
					alt=""
				/>
			)) || <span className={prefixClassName('image-placeholder')} />}
			{text && (
				<span className={prefixClassName('image-text')}>({text})</span>
			)}
		</span>
	);
};

export default ImageWithText;
